module.exports = __webpack_public_path__ + "static/img/indexPic1.ecf32af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic1.png
// module id = /qGt
// module chunks = 1